import { graphql } from "gatsby";
import React, { useRef } from "react";

import AboutUsPageComponent from "../components/about-us";
import ContactUsPageComponent from "../components/contact-us";
import Layout from "../components/layout";
import NavigateToParentSite from "../components/navigateToParentSite";
import Newsletter from "../components/newsletter";
import Seo from "../components/seo";
import Hero from "../components/shared/hero";
import { ThemeContext } from "../context/ThemeContext";
import { useBannerDetails } from "../hooks/useBannerManager";
import BlogPage from "../pages/blog";
import { formatHeroBackgroundOptions } from "../utils/formatContent";
import {
  appFormSlug,
  genericFormSlugs,
  templateList
} from "../utils/sharedDatasets";

const DefaultPageTemplate = (props) => {
  const { data } = props;

  const page = data?.page;
  const { acfLandingPage, globalConfig } = page;
  const wpTemplate =
    page && data && page.template && page.template.templateName
      ? page.template.templateName.toLowerCase()
      : "default";

  const heroOpts = formatHeroBackgroundOptions(globalConfig);

  const heroBackgroundImage = heroOpts?.image?.desktop;
  const heroBackgroundVideo = heroOpts?.video?.desktop;
  const heroBackgroundImageMobile = heroOpts?.image?.mobile;

  const headerIcons = (acfLandingPage && acfLandingPage?.genHeaderIcons) ?? [];
  const groupProgramSourceType =
    acfLandingPage?.genProgramListSourceType === "group_programs";

  const heroNavLinks = headerIcons?.map((icon, idx) => {
    return {
      imgPath: "location-icon.svg",
      toPage: "#",
      text: `Something something-${idx}`
    };
  });

  // console.debug("debug page :: defaultPageTemplate", {
  //   wpTemplate: wpTemplate,
  //   title: page?.title,
  //   template: page?.template?.templateName?.toLowerCase(),
  //   slug: page?.slug
  // });

  const isNoProgram = true;
  const isHomepage = false;

  const heroOverlayTitle = acfLandingPage?.genHeaderOverlayTitle ?? "";

  const heroRef = useRef(null);

  let applyNow = "/application-form/";
  let enquireNow = "/enquiry-form/";

  if (groupProgramSourceType === true) {
    applyNow = `/application-form/?group_source=${true}`;
    enquireNow = `/enquiry-form/?type=group_enquiry`;
  }

  const banner = useBannerDetails(page?.slug);

  const enquireUKCardDetails = {
    footerTitle: banner?.title ?? "",
    footerSubtitle: banner?.desc ?? "",
    footerImage: banner?.image || null,
    cardBookDesc: "",
    enquireNowCtaTitle: "Enquire",
    footerCtaTitle: "Apply",
    footerSubtitleClass: "text-sm planet:text-white text-black-lighter",
    contentContainerClass: "sm:w-2/5",
    cardBookDescSpanClass:
      "text-xs font-semibold text-left sm:font-normal planet:text-white text-generic-text",
    applicationFormLink: applyNow,
    enquireNowLink: enquireNow,
    enquireBtn: true,
    allowCookieControl: false,
    displayCloseButton: false,
    footerPromoCookieName: [
      "isPromoStickyFooterShow",
      page?.id ?? page?.slug
    ].join(""),
    heroRef: heroRef
  };

  return (
    <ThemeContext.Consumer>
      {(theme) => (
        <Layout
          pageTitle={page.title}
          containerClass={
            isHomepage
              ? "w-full mx-auto homepage stickyContainer"
              : "w-full mx-auto"
          }
          enquireNow={enquireNow}
          applyNow={applyNow}
          brandingOpts={{ ...theme }}
          stickyFooterDetails={enquireUKCardDetails}
        >
          <>
            {!isHomepage &&
              (!appFormSlug.includes(page.slug) || isNoProgram) &&
              !genericFormSlugs.includes(page.slug) && (
                <div ref={heroRef}>
                  <Hero
                    heroHeadLine={heroOverlayTitle}
                    heroImg={heroBackgroundImage}
                    navLinks={heroNavLinks ?? ""}
                    videoId={heroBackgroundVideo}
                    heroImageMobile={heroBackgroundImageMobile}
                  />
                </div>
              )}

            {page.slug === "about-us" && (
              <AboutUsPageComponent page={page} data={data} />
            )}

            {page.slug === "contact-us" && (
              <ContactUsPageComponent data={data} />
            )}

            {page.slug === "blog" && <BlogPage data={data} />}

            {!isHomepage &&
              page.slug !== "about-us" &&
              page.slug !== "contact-us" &&
              page.slug !== "blog" &&
              page.slug !== "find-a-program" &&
              !appFormSlug.includes(page.slug) &&
              !genericFormSlugs.includes(page.slug) &&
              !templateList.includes(wpTemplate) && <NavigateToParentSite />}

            {(isNoProgram ||
              (!appFormSlug.includes(page.slug) &&
                !genericFormSlugs.includes(page.slug) &&
                templateList.includes(wpTemplate) &&
                !isHomepage)) &&
              page.slug !== "thank-you-for-your-payment" && <Newsletter />}
          </>
        </Layout>
      )}
    </ThemeContext.Consumer>
  );
};

export const Head = ({ data }) => {
  const page = data?.page ?? {};

  return (
    <Seo
      title={page?.seoLegacy?.title ?? page?.seo?.title ?? page.title}
      description={page?.seoLegacy?.description ?? page?.seo?.description}
      image={page?.globalConfig?.backgroundImage?.sourceUrl}
      translations={page?.translations}
      lang={page?.locale}
      meta={[
        {
          name: "robots",
          content: page?.seoLegacy?.robots ?? page?.seo?.robots
        }
      ]}
    />
  );
};

export const pageQuery = graphql`
  query ($id: String!) {
    page: wpPage(id: { eq: $id }) {
      ...WpPageFragment
    }

    blogPosts: allWpPost(limit: 5, sort: { modified: DESC }) {
      nodes {
        ...miniBlogPostsFragment
      }
    }
  }
`;

export default DefaultPageTemplate;
